import React from "react";
import PropTypes from "prop-types";
import { Title } from "rbx";
import FollowupListItem from "../FollowupListItem";

const CompletedFollowupsList = ({
  followupsLength,
  handleClick,
  completedFollowups,
  setFollowups,
  isCompletedSection
}) => (
    <React.Fragment>
      {completedFollowups?.map((followup, index) => (
        <React.Fragment key={followup?.id}>
          <FollowupListItem
            isCompletedSection
            followup={followup}
            followupIndex={index}
            handleClick={handleClick}
          />
        </React.Fragment>
      ))}
      {!completedFollowups.length  && (
        <div className="centered-title">
          <Title size={6}>
            No Current Completed Follow-ups
          </Title>
        </div>
      )}
    </React.Fragment>
  );

CompletedFollowupsList.propTypes = {
  followupsLength: PropTypes.number.isRequired,
  handleClick: PropTypes.func.isRequired,
  completedFollowups: PropTypes.array.isRequired,
  setFollowups: PropTypes.func.isRequired,
  isCompletedSection: PropTypes.bool
};

CompletedFollowupsList.defaultProps = {
  isCompletedSection: true
};

export default CompletedFollowupsList; 